import { Box, Container, Typography } from '@mui/material';
import React from 'react';

import SubscriptionPurchaseOptions from '../components/SubscriptionPurchaseOptions';
import HeroSection from '../theme/HeroSection';

const SubscriptionsPage: React.FC = () => {
  return (
    <Box data-testid="subscriptions-page">
      <HeroSection
        minHeight="clamp(296px, 24vh, 240px)"
        showWave
        imageUrl="/images/SeanValentine-HGP.jpg"
      >
        <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1, py: { xs: 1.5, sm: 2 } }}>
          <Box sx={{ maxWidth: 560 }}>
            <Typography
              variant="h3"
              component="h1"
              sx={{
                color: 'white',
                fontWeight: 'bold',
                mb: 0.5,
                fontSize: { xs: '1.35rem', sm: '1.75rem' },
                lineHeight: 1.2,
              }}
            >
              Membership
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'rgba(255,255,255,0.92)',
                lineHeight: 1.35,
                fontSize: { xs: '0.8rem', sm: '0.875rem' },
              }}
            >
              One membership, the whole 12-session journey. Start with a 7-day free trial.
            </Typography>
          </Box>
        </Container>
      </HeroSection>

      <Container maxWidth="md" sx={{ py: { xs: 1, sm: 2 }, px: { xs: 2, sm: 3 } }}>
        <SubscriptionPurchaseOptions />
      </Container>
    </Box>
  );
};

export default SubscriptionsPage;
